import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";

import { DashboardService } from "@core/services/dashboard.service";
import { environment } from "@env/environment";
import { catchError, Observable, throwError } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class RegisterInterceptor implements HttpInterceptor {
  private authHeader: string = "Authorization";

  constructor(private dashboardService: DashboardService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!req.withCredentials) {
      req = req.clone({
        withCredentials: true,
      });
    }

    req = this.appendProcessToken(req);
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse): Observable<HttpEvent<never>> => {
        if (error.status === 401) {
          window.location.replace(`${environment.BASE_AUTH_URL}Account/Login`);
        }
        return throwError((): HttpErrorResponse => error);
      })
    );
  }

  private addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {
    return request.clone({
      headers: request.headers.set(
        this.authHeader,
        `X-Xsrf-Token ${this.dashboardService.authToken}`
      ),
    });
  }

  private appendProcessToken(request: HttpRequest<any>): HttpRequest<any> {
    return this.addAuthenticationToken(request);
  }
}
